require('../custom/utils');
/*
 * Algolia Utility functions
 *
 * This script should be CENTER PLACE of defining
 * all custom logic related to Algolia Search like,
 * excluding 'COLOR BLOCK' and 'COLOR BLANKET',
 * Non-Collaborations in Collaboration value.
 **/

custom.shopifyApi = (function () {
  /**
   * getProductJson
   *
   * @param {string} handle - product handle (ex. cam-04-stone-stone)
   * - Returns Product information in json format
   * - All information schema is defined in bold-product-ed.liquid
   */
  function getProductJson(handle = '') {
    return $.ajax({
      type: 'GET',
      url: `/products/${handle}?view=json`,
    });
  }

  /**
   * getShopifyProductJson
   *
   * @param {string} handle - product handle
   * - AJAX call to get all product information
   * - provided by Shopify.
   */
  const getShopifyProductJson = (handle = '') => {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open('GET', `/products/${handle}.json`, true);
      xhr.timeout = 5000;
      xhr.send();
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.responseText));
          } else {
            // Instead of rejecting, RESOLVE the Promise with "false"
            // so that success callback gets called everytime.
            console.log(
              `Error: ${handle} exists on Algolia, however not on Shopify.`,
            );
            custom.utils.sendCustomSentryError(
              'Error, product exists on Algolia, however not on Shopify.',
              {
                extra: { handle: handle },
              },
            );
            resolve(false);
          }
        }
      };
      xhr.ontimeout = function (e) {
        // XMLHttpRequest timed out. Do something here.
        console.log(
          `Timeout: ${handle} request to Shopify took longer than 5000ms.`,
        );
        resolve(false);
      };
    });
  };

  function removeErrorPromiseFromArray(errorPromise = {}, promises = []) {
    let index = null;
    promises.forEach((promise, i) => {
      if (promise == errorPromise) index = i;
    });
    if (index !== null) promises.splice(index, 1);
    return promises;
  }

  // TODO make endpoint call use a global variable for 'https://muapp.loloirugs.com'
  /**
   * getHoverImages
   *
   * @param {array} shopifyIds - shopify product ids
   * - AJAX call to get certain product card hover images
   * - custom API route from MU App
   */
  const getHoverImages = (shopifyIds = '') => {
    return $.ajax({
      type: 'GET',
      url: window.MUAPP.url + `api/v1/hover_images?shopifyIds=${shopifyIds}`,
      dateType: 'json',
    });
  };

  return {
    getProductJson,
    getShopifyProductJson,
    removeErrorPromiseFromArray,
    getHoverImages,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/shopify-api.js